(function() {

  const SHOP_DOMAIN = 'smartstorage.au';
  const STOREFRONT_TOKEN = 'b8c6a34131a303a6aae79dbfe22e4e87';
  const COLLECTION_HANDLE = 'garage-shelving';

  const state = {
    maxHeight: 5,
    heightSkipped: true,
    maxWidth: 5,
    widthSkipped: true,
    depth: 'any',
    material: 'any'
  };

  let allProducts = [];

  // ============================================================
  // FETCH PRODUCTS
  // ============================================================
  async function fetchAllProducts() {
    const query = `{
      collection(handle: "${COLLECTION_HANDLE}") {
        products(first: 100) {
          edges {
            node {
              id
              title
              handle
              tags
              priceRange { minVariantPrice { amount } }
              compareAtPriceRange { minVariantPrice { amount } }
              featuredImage { url }
              metafields(identifiers: [
                {namespace: "custom", key: "shelf_height_m"},
                {namespace: "custom", key: "shelf_width_m"},
                {namespace: "custom", key: "shelf_depth_cm"},
                {namespace: "custom", key: "shelf_material"},
                {namespace: "custom", key: "unit_count"},
                {namespace: "custom", key: "weight_capacity_kg"}
              ]) { key value }
            }
          }
        }
      }
    }`;

    try {
      const res = await fetch(`https://${SHOP_DOMAIN}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query })
      });
      const data = await res.json();
      const edges = data?.data?.collection?.products?.edges || [];
      allProducts = edges.map(e => {
        const p = e.node;
        const mf = {};
        (p.metafields || []).forEach(m => { if (m) mf[m.key] = m.value; });
        return {
          id: p.id,
          title: p.title,
          handle: p.handle,
          tags: p.tags || [],
          price: parseFloat(p.priceRange?.minVariantPrice?.amount || 0),
          compareAtPrice: parseFloat(p.compareAtPriceRange?.minVariantPrice?.amount || 0),
          image: p.featuredImage?.url || '',
          height_m: parseFloat(mf['shelf_height_m'] || 0),
          width_m: parseFloat(mf['shelf_width_m'] || 0),
          depth_cm: parseInt(mf['shelf_depth_cm'] || 0),
          material: (mf['shelf_material'] || '').toLowerCase(),
          unit_count: parseInt(mf['unit_count'] || 1),
          weight_kg: parseInt(mf['weight_capacity_kg'] || 0)
        };
      });
      renderResults();
    } catch(e) {
      console.error('Garage shelving filter fetch error:', e);
      document.getElementById('gs-product-grid').innerHTML =
        '<p style="padding:40px;text-align:center;color:#999;grid-column:1/-1;">Unable to load products right now. Please refresh the page.</p>';
    }
  }

  // ============================================================
  // FILTER LOGIC
  // ============================================================
  function filterProducts() {
    return allProducts.filter(p => {
      if (!state.heightSkipped) {
        if (!p.height_m) return false; // no data = exclude when filtering
        if (p.height_m > state.maxHeight + 0.05) return false;
      }
      if (!state.widthSkipped) {
        if (!p.width_m) return false;
        if (p.width_m > state.maxWidth + 0.05) return false;
      }
      if (state.depth !== 'any') {
        if (p.depth_cm !== parseInt(state.depth)) return false;
      }
      if (state.material !== 'any') {
        if (p.material !== state.material) return false;
      }
      return true;
    });
  }

  function isAnyFilterActive() {
    return !state.heightSkipped || !state.widthSkipped || state.depth !== 'any' || state.material !== 'any';
  }

  // ============================================================
  // RENDER
  // ============================================================
  function renderResults() {
    const matched = filterProducts();
    const grid = document.getElementById('gs-product-grid');
    const title = document.getElementById('gs-results-title');
    const clearLink = document.getElementById('gs-clear-link');
    const countEl = document.getElementById('gs-count');

    countEl.style.transform = 'scale(1.25)';
    countEl.textContent = matched.length;
    setTimeout(() => countEl.style.transform = 'scale(1)', 250);

    const active = isAnyFilterActive();
    clearLink.style.display = active ? 'inline' : 'none';

    if (!active) {
      title.textContent = 'All Garage Shelving';
    } else {
      title.textContent = matched.length > 0
        ? `${matched.length} Unit${matched.length !== 1 ? 's' : ''} Matching Your Space`
        : 'No Exact Matches';
    }

    if (matched.length === 0) {
      grid.innerHTML = `
        <div class="gs-no-results" style="grid-column:1/-1">
          <h3>We don't have an exact match for that combination right now</h3>
          <p>Send us your space dimensions and what you need to store, and our team will help find or source the right shelving — usually within 24 hours.</p>
          <a href="/pages/contact" class="gs-contact-btn">📞 Get Help Finding Shelving</a>
        </div>`;
      return;
    }

    const sorted = [...matched].sort((a, b) => a.price - b.price);

    grid.innerHTML = sorted.map(p => {
      const specs = [];
      if (p.height_m) specs.push(`${p.height_m.toFixed(1)}m high`);
      if (p.width_m) specs.push(`${p.width_m.toFixed(1)}m wide`);
      if (p.depth_cm) specs.push(`${p.depth_cm}cm deep`);
      if (p.material) specs.push(p.material === 'mdf' ? 'MDF shelves' : 'Steel shelves');
      if (p.weight_kg) specs.push(`${p.weight_kg}kg/shelf`);

      return `
      <a href="/products/${p.handle}" class="gs-product-card">
        ${p.image ? `<img src="${p.image}&width=400" alt="${p.title}" loading="lazy">` : ''}
        <div class="gs-card-body">
          ${isAnyFilterActive() ? '<div class="gs-match-badge">✓ Matches your space</div>' : ''}
          <p class="gs-card-title">${p.title}</p>
          <p class="gs-card-specs">${specs.join(' • ')}</p>
          <div class="gs-price-row">
            ${p.compareAtPrice > p.price ? `<span class="gs-price-was">$${p.compareAtPrice.toFixed(2)}</span>` : ''}
            <span class="gs-card-price ${p.compareAtPrice > p.price ? 'gs-price-sale' : ''}">$${p.price.toFixed(2)}</span>
          </div>
          <span class="gs-btn-primary">View Details →</span>
        </div>
      </a>`;
    }).join('');
  }

  // ============================================================
  // EVENT LISTENERS
  // ============================================================
  // Toggle: hide/show the smart filter
const toggleBtn = document.getElementById('gs-hide-toggle');
const toggleText = document.getElementById('gs-toggle-text');
const toggleIcon = document.getElementById('gs-toggle-icon');
const filterApp = document.getElementById('gs-filter-app');

toggleBtn.addEventListener('click', function() {
  const isCollapsed = filterApp.classList.toggle('gs-collapsed');
  if (isCollapsed) {
    toggleText.textContent = 'Show Smart Filter';
    toggleIcon.textContent = '🔍';
    sessionStorage.setItem('gsFilterCollapsed', 'true');
  } else {
    toggleText.textContent = 'Just browsing? Hide the filter';
    toggleIcon.textContent = '🙈';
    sessionStorage.removeItem('gsFilterCollapsed');
  }
});

// Remember their choice for this browsing session
if (sessionStorage.getItem('gsFilterCollapsed') === 'true') {
  filterApp.classList.add('gs-collapsed');
  toggleText.textContent = 'Show Smart Filter';
  toggleIcon.textContent = '🔍';
}

  const heightSlider = document.getElementById('gs-height-slider');
  const heightVal = document.getElementById('gs-height-val');
  heightSlider.addEventListener('input', function() {
    const v = parseFloat(this.value);
    if (v >= 5) {
      state.heightSkipped = true;
      heightVal.textContent = 'Any height';
    } else {
      state.heightSkipped = false;
      state.maxHeight = v;
      heightVal.textContent = 'Up to ' + v.toFixed(1) + 'm';
    }
    renderResults();
  });

  const widthSlider = document.getElementById('gs-width-slider');
  const widthVal = document.getElementById('gs-width-val');
  widthSlider.addEventListener('input', function() {
    const v = parseFloat(this.value);
    if (v >= 5) {
      state.widthSkipped = true;
      widthVal.textContent = 'Any width';
    } else {
      state.widthSkipped = false;
      state.maxWidth = v;
      widthVal.textContent = 'Up to ' + v.toFixed(1) + 'm';
    }
    renderResults();
  });

  document.querySelectorAll('#gs-depth-pills .gs-pill').forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('#gs-depth-pills .gs-pill').forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      state.depth = this.dataset.depth;
      renderResults();
    });
  });

  document.querySelectorAll('#gs-material-pills .gs-pill').forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('#gs-material-pills .gs-pill').forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      state.material = this.dataset.material;
      renderResults();
    });
  });

  document.getElementById('gs-reset').addEventListener('click', function() {
    state.heightSkipped = true;
    state.widthSkipped = true;
    state.depth = 'any';
    state.material = 'any';

    heightSlider.value = 5;
    heightVal.textContent = 'Any height';
    widthSlider.value = 5;
    widthVal.textContent = 'Any width';

    document.querySelectorAll('#gs-depth-pills .gs-pill').forEach(b => b.classList.remove('selected'));
    document.querySelector('#gs-depth-pills .gs-pill[data-depth="any"]').classList.add('selected');

    document.querySelectorAll('#gs-material-pills .gs-pill').forEach(b => b.classList.remove('selected'));
    document.querySelector('#gs-material-pills .gs-pill[data-material="any"]').classList.add('selected');

    renderResults();
  });

  document.getElementById('gs-clear-link').addEventListener('click', function() {
    document.getElementById('gs-reset').click();
  });

  // ============================================================
  // INIT
  // ============================================================
  fetchAllProducts();

})();